<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">{{ page_title }} Gifts</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Marketing</b> /
      <b>{{ page_title }} Gifts</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left mb-4">

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_approved" role="tab"
                aria-controls="_approved" aria-selected="true" @click="changeTitle('Approved')">Approved</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_pending" role="tab"
                aria-controls="_pending" aria-selected="false" @click="changeTitle('Pending')">Pending</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active bg-white" id="_approved" role="tabpanel" aria-labelledby="approved-tab">
              <div class="card-body">
                <h4 class="card-title mb-3">
                  <b>Active</b>
                </h4>
    
                <p>Below are the list of approved gifts. Only gifts with available quota will be displayed in the mobile app.</p>
                <form @submit.prevent="handleSubmission">
                  <div class="mb-3">
                    <label>Note for empty gift</label>
                    <input class="form-control" type="text" v-model="data.note.content" />
                  </div>
                  
                  <div class="mb-4">
                    <label>Upload Image Link</label><br />
                    <img :src="data.note.image_link" class="img-fluid" width="400" /><br />
                    <input
                      type="file"
                      ref="file"
                      class="inputfile"
                      v-on:change="handleFileUpload"
                    />
                  </div>

                  <div class="mb-4">
                    <label>Banner Link</label><br />
                    <img :src="data.banner.image_link" class="img-fluid" width="400" /><br />
                    <input
                      type="file"
                      ref="bannerFile"
                      class="inputfile"
                      v-on:change="handleUploadBanner"
                    />
                  </div>
      
                  <div class="row mb-4">
                    <div class="col">
                      <label><b>General Title</b></label>
                      <input class="form-control" type="text" v-model="data.titles[0].title" />
                    </div>
                    <div class="col">
                      <label><b>Black Title</b></label>
                      <input class="form-control" type="text" v-model="data.titles[1].title" />
                    </div>
                    <div class="col">
                      <label><b>Platinum Title</b></label>
                      <input class="form-control" type="text" v-model="data.titles[2].title" />
                    </div>
                    <div class="col">
                      <label><b>Gold Title</b></label>
                      <input class="form-control" type="text" v-model="data.titles[3].title" />
                    </div>
                    <div class="col">
                      <label><b>Silver Title</b></label>
                      <input class="form-control" type="text" v-model="data.titles[4].title" />
                    </div>
                  </div>
      
                  <div class="row">
                    <div class="col">
                      <label><b>General Subtitle</b></label>
                      <input class="form-control" type="text" v-model="data.titles[0].subtitle" />
                    </div>
                    <div class="col">
                      <label><b>Black Subtitle</b></label>
                      <input class="form-control" type="text" v-model="data.titles[1].subtitle" />
                    </div>
                    <div class="col">
                      <label><b>Platinum Subtitle</b></label>
                      <input class="form-control" type="text" v-model="data.titles[2].subtitle" />
                    </div>
                    <div class="col">
                      <label><b>Gold Subtitle</b></label>
                      <input class="form-control" type="text" v-model="data.titles[3].subtitle" />
                    </div>
                    <div class="col">
                      <label><b>Silver Subtitle</b></label>
                      <input class="form-control" type="text" v-model="data.titles[4].subtitle" />
                    </div>
                  </div>
      
                  <div class="d-flex justify-content-end mt-4">
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </form>
    
                <hr />
    
                <div class="table-responsive">
                  <div class="mb-4 mr-3">
                    <div class="float-right">
                      <div class="btn-group mb-4" role="group" v-for="(button, index) in buttons" :key="index">
                        <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
                          :class="{ 'change-background': button.status }" @click="onPressBtn(index)" type="button">
                          {{ button.name }}
                        </button>
                      </div>
                    </div>
                  </div>
    
                  <table
                    id="marketing_gifts"
                    class="display table table-striped table-bordered"
                    style="width:100%; text-align: center;"
                  >
                    <thead>
                      <tr>
                        <th style="width: 5% !important">No.</th>
                        <th style="width: 15% !important">Company Name</th>
                        <th style="width: 15% !important">Name</th>
                        <th style="width: 15% !important">Image</th>
                        <th style="width: 5% !important">Expiry</th>
                        <th style="width: 5% !important">Available Quantity</th>
                        <th style="width: 15% !important">Type</th>
                        <th style="width: 25% !important">Message</th>
                        <th style="width: 5% !important">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(gift, index) in gifts" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ gift.vendor_name }}</td>
                        <td>{{ gift.name }}</td>
                        <td>
                          <img :src="gift.image" class="img-fluid" width="200" />
                        </td>
                        <td>{{ gift.expiry }}</td>
                        <td>{{ gift.quantity_remained }}</td>
                        <td>
                          <div v-if="gift.hasOwnProperty('tiers')">
                            {{ formatTiers(gift.tiers) }}
                          </div>
                          <div v-else>General</div>
                        </td>
                        <td>{{ limitText(gift.long_message, 11) }}</td>
                        <td>
                          <router-link :to="goTo(gift.id)" class="btn btn-primary btn-block">View Details</router-link>
                          <button :disabled="isLoading" @click="handleActivationStatus(gift)" class="btn btn-block" :class="gift.active == 1 ? 'btn-danger' : 'btn-success'"> {{ gift.active == 1 ? 'Deactivate' : 'Activate' }}</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
  
            </div>

            <div class="tab-pane fade bg-white" id="_pending" role="tabpanel" aria-labelledby="pending-tab">
              <div class="card-body">
                <h4 class="card-title mb-3">
                  <b>Pending Gift</b>
                </h4>

                <div class="table-responsive">    
                  <table
                    id="pending_gifts"
                    class="display table table-striped table-bordered"
                    style="width:100%; text-align: center;"
                  >
                  <thead>
                      <tr>
                        <th style="width: 5% !important">No.</th>
                        <th style="width: 20% !important">Company Name</th>
                        <th style="width: 20% !important">Name</th>
                        <th style="width: 15% !important">Image</th>
                        <th style="width: 15% !important">Expiry</th>
                        <th style="width: 15% !important">Available Quantity</th>
                        <th style="width: 15% !important">Type</th>
                        <th style="width: 25% !important">Message</th>
                        <th style="width: 5% !important">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(gift, index) in pending" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ gift.vendor_name }}</td>
                        <td>{{ gift.name }}</td>
                        <td>
                          <img :src="gift.image" class="img-fluid" width="200" />
                        </td>
                        <td>{{ gift.expiry }}</td>
                        <td>{{ gift.quantity_remained }}</td>
                        <td>
                          <div v-if="gift.hasOwnProperty('tiers')">
                            {{ formatTiers(gift.tiers) }}
                          </div>
                          <div v-else>General</div>
                        </td>
                        <td><span v-html="gift.long_message"></span></td>
                        <td>
                          <button :disabled="isLoading" @click="handleApproval(gift)" class="btn btn-block btn-success"> Approve </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>


<script>
import { getGifts, storeGift, activateGift, deactivateGift, approveGift } from '../../../services/GiftServices';
export default {

  data() {
    return {
      isLoading: false,
      gifts: [],
      buttons: [
        { status: true, name: "Active", flag: 1},
        { status: false, name: "Inactive", flag: 2 },
      ],

      clone_gifts: [],

      selectedIndex: 0,

      dataTable: null,

      page_title: 'Approved',

      data: {
        titles: [
          {
            id: 1,
            title: "General",
            subtitle: "Please select one of the gifts available"
          },
          {
            id: 2,
            title: "Exclusive for Black",
            subtitle: "Please select one of the gifts available"
          },
          {
            id: 3,
            title: "Exclusive for Platinum",
            subtitle: "Please select one of the gifts available"
          },
          {
            id: 4,
            title: "Exclusive for Gold",
            subtitle: "Please select one of the gifts available"
          },
          {
            id: 5,
            title: "Exclusive for Silver",
            subtitle: "Please select one of the gifts available"
          }
        ],
        note: {
          content: '',
          image_link: '',
          upload: ''
        },
        banner: {
          image_link: '',
          upload: ''
        }
      },

      pending: [],
      active: [],
      inactive: []
    }
  },

  methods: {
    handleFileUpload() {
      this.data.note.upload = this.$refs.file.files[0];
      this.data.note.image_link = URL.createObjectURL(this.data.note.upload);

    },

    handleUploadBanner() {
      this.data.banner.upload = this.$refs.bannerFile.files[0];
      this.data.banner.image_link = URL.createObjectURL(this.data.banner.upload);
    },

    goTo(id) {
      return `/marketing/gift/edit/${id}`;
    },

    async fetchData() {
      try {
        const response = await getGifts();

        if(response.data.success) {
          this.data.note = response.data.data.note;
          this.data.titles = response.data.data.titles;
          this.data.banner = response.data.data.banner;
          this.pending = response.data.data.pending;
          this.active = response.data.data.active;
          this.inactive = response.data.data.inactive;
        }

        this.data.note.upload = null;
        this.data.banner.upload = null;

        this.checkData();
      } catch (e) {
        console.error(e);
      }
    },

    appendForm() {
      const formData = new FormData();
      if(this.data.note.upload != null) {
        formData.append('note[image]', this.data.note.upload);
      }
      formData.append('note[content]', this.data.note.content);

      this.data.titles.forEach((item, index) => {
        formData.append(`titles[${index}][id]`, item.id);
        formData.append(`titles[${index}][title]`, item.title);
        formData.append(`titles[${index}][subtitle]`, item.subtitle);
      })

      if(this.data.banner.upload != null) {
        formData.append('banner[image]', this.data.banner.upload);
      }

      return formData;
    },

    async handleSubmission() {

      try {
        const response = await storeGift(this.appendForm());

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });
      } catch (e) {
        console.error(e)
      }
    },

    async handleActivationStatus(gift) {
      this.isLoading = true;

      let functionUse = activateGift;

      if(gift.active == 1) {
        functionUse = deactivateGift;
      }  else {
        functionUse = activateGift;
      }

      try {
        const response = await functionUse({}, gift.id);
        
        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if(response.data.success) {
          if (this.dataTable) {
            this.dataTable.destroy();
          }

          if(gift.active == 1) {
            gift.active = 0;
            this.moveObjectById(gift.id, "active", "inactive");
          } else {
            gift.active = 1;
            this.moveObjectById(gift.id, "inactive", "active");
          } 

          this.$nextTick(() => {
            this.dataTable = this.loadTable("#marketing_gifts");
          });
        }
      } catch (e) {
        console.error(e)
      }

      this.isLoading = false;

    },

    async handleApproval(gift) {
      try {
        const response = await approveGift({}, gift.id);

        swal({
          icon: response.data.success ? 'success' : 'error',
          text: response.data.message
        });

        if(response.data.success) {
          this.destroyDataTable('#pending_gifts');
          await this.fetchData();
          this.loadTable("#pending_gifts");

        }
      } catch (e) {
        console.error(e)
      }
    },

    moveObjectById(id, sourceArray, destinationArray) {
      const index = this[sourceArray].findIndex(obj => obj.id === id);

      if (index !== -1) {
        const removedObject = this[sourceArray].splice(index, 1)[0];
        this[destinationArray].push(removedObject);
      }
    },

    onPressBtn(int) {
      this.selectedIndex = int;

      this.buttons.forEach((button, index) => {
        button.status = int === index;
      });

      if (this.dataTable) {
        this.dataTable.destroy();
      }

      this.checkData();

      this.$nextTick(() => {
        this.dataTable = this.loadTable("#marketing_gifts");
      });
    },

    checkData() {
      switch (this.selectedIndex) {
        case 0:
          this.gifts = this.active;
          return;
        case 1:
          this.gifts = this.inactive;
          return;
      }
    },

    destroyDataTable(name) {
      $(name).DataTable().destroy();
    },

    loadTable(name) {
      return $(name).DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 3, 4, 5, 6],
              columns: ':not(:last-child)',
            }
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
              columns: [0, 1, 3, 4, 5, 6],
              columns: ':not(:last-child)',
            }
          }
        ]
      });
    },

    formatTiers(tiers) {
      JSON.stringify(tiers);
      const name = tiers.map(item => item.name.charAt(0).toUpperCase() + item.name.slice(1)).join(', ');
      return name;
    },

    changeTitle(name) {
      this.page_title = name;
    },

    limitText(text, limit) {
      if(text == null || text == '') {
        return text;
      }
      
      const words = text.split(/\s+/);
      if (words.length > limit) {
        return words.slice(0, limit).join(" ") + "...";
      }
      return text;
    }
  },

  async mounted() {
    await this.fetchData();
    this.dataTable = this.loadTable("#marketing_gifts");
    this.loadTable("#pending_gifts");
  },
}
</script>


<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
